import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ButtonPill } from 'components/shared/MuiExtensions';
import { setNotification } from 'state/app.state';
import { RootState } from 'state/store';
import { buildLeadComment, formatPhoneNumber } from 'utils/functions';

import { ReactComponent as CopyIcon } from 'assets/images/content_copy.svg';

const CopyLeadDetails = () => {
  const dispatch = useDispatch();
  const leadDetails = useSelector((state: RootState) => {
    if (!state.lead.entity) return '';

    const {
      firstName = '',
      lastName = '',
      phone = '',
      email = '',
      leadComment = '',
      additionalNote = '',
    } = state.lead.entity;
    const { scriptResponseSummaryString } = state.script;
    const fullName = `${firstName} ${lastName}`.trim();
    // TODO: UNI-6998
    // known bug - this does not update in real time with lead summary
    const newLeadComment = buildLeadComment(
      // @ts-ignore
      leadComment,
      additionalNote,
      scriptResponseSummaryString
    );
    return [fullName, formatPhoneNumber(phone || undefined), email, newLeadComment]
      .filter((val) => val)
      .join('\n');
  });

  const copyLeadDetails = () => {
    // navigator may not always have the clipboard property, need to prevent TypeScript from failing
    const navigator = window.navigator as any;

    // do we have the clipboard API?
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      if (!leadDetails) {
        dispatch(setNotification({ type: 'error', text: 'No lead details to copy' }));
      }
      navigator.clipboard.writeText(leadDetails).then(
        () => dispatch(setNotification({ type: 'success', text: 'Lead details copied' })),
        () => dispatch(setNotification({ type: 'error', text: 'Could not copy lead details' }))
      );
    } else {
      dispatch(setNotification({ type: 'error', text: 'Could not copy lead details' }));
    }
  };

  return (
    <ButtonPill
      type="button"
      startIcon={<CopyIcon width="1rem" height="1rem" />}
      onClick={copyLeadDetails}
    >
      Copy Lead Details
    </ButtonPill>
  );
};

export default CopyLeadDetails;
